import { Box,Stack,Tab,Tabs } from "@mui/material";
import { useContext,useState } from "react";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../context/UserContext";
import { trackEventMatomo } from '../../helpers/matomo';
import { TabPanelProps } from "../../types/helpers/types";
import AddCustomer from "./AddCustomer";
import AddCustomerTag from "./AddCustomerTag";
import RegisteredCustomers from "./RegisteredCustomers";


function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      style={{ width: '100%' }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function TicketsTabs() {
  const { hierarchyLabel } = useContext(UserContext);
  const { t } = useTranslation('translation');
  const [value, setValue] = useState<number>(0);
  function handleChange(_event: React.SyntheticEvent, newValue: number) {
    const tabs = ['clientes cadastrados', 'novo cliente', 'tags de clientes'];
    trackEventMatomo('gestão de clientes', 'click', 'aba', tabs[newValue]);
    setValue(newValue);
  };

  return (
    <>
      <Stack width='100%' alignItems='flex-start' justifyContent='flex-start'>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
          >
            <Tab label={t('customerPage.myCustomer') + ' ' + hierarchyLabel.cliente} value={0} />
            <Tab label={t('customerPage.addCustomer') + ' ' + hierarchyLabel.cliente} value={1} />
            <Tab label={t('customerPage.customerTags')} value={2} />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <RegisteredCustomers />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <AddCustomer />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <AddCustomerTag />
        </CustomTabPanel>
      </Stack>
    </>
  );
}
